/**
 * API Endpoints
 *
 * Centralized endpoint definitions for all API calls.
 * Use these constants instead of hardcoding endpoint strings.
 */

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    FORGOT_PASSWORD: '/auth/forgot-password',
    SET_PASSWORD: '/auth/set-password',
    VERIFY_TOKEN: '/auth/verify-token',
    CHANGE_PASSWORD: '/auth/change-password',
    INVITE: '/auth/invite',
  },
  USERS: {
    BASE: '/users',
    ME: '/users/me',
    BY_ID: (id: string | number) => `/users/${id}`,
  },
  ZONES: {
    BASE: '/zones',
    BY_ID: (id: string) => `/zones/${id}`,
    SEARCH: '/zones/search',
    CALCULATE_DISTANCE: '/zones/calculate-distance',
  },
  LOCATIONS: {
    LOOKUP: '/locations/lookup',
  },
} as const
